/** First moment of the maintenance window, 7 November 2026 1:30 AM Saudi time. */
export const MAINTENANCE_START_MS = Date.parse('2026-11-07T01:30:00+03:00');

/** First moment after the maintenance window, 7 November 2026 7:30 AM Saudi time. */
export const MAINTENANCE_END_MS = Date.parse('2026-11-07T07:30:00+03:00');
